import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { datadogRum } from '@datadog/browser-rum';

// React error boundaries require a class component — there is no hook equivalent
// for getDerivedStateFromError/componentDidCatch. This is the app's last-resort
// safety net: without it, any uncaught render error unmounts the whole React root
// and the page goes blank.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    datadogRum.addError(error, errorInfo);
  }

  handleReload = () => {
    window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: 2,
            padding: 4,
            minHeight: '50vh',
          }}
        >
          <Typography variant="h5">Something went wrong.</Typography>
          <Typography variant="body1" color="text.secondary">
            An unexpected error occurred. Please try reloading the page.
          </Typography>
          <Button variant="contained" onClick={this.handleReload}>
            Reload
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
